export class DnDFileController {

    private dragenter;
    private dragover;
    private dragleave;
    private drop;

    constructor(selector, onDropCallback) {
        var el = document.querySelector(selector);

        this.dragenter = e => {
            e.stopPropagation();
            e.preventDefault();
            el.classList.add("dropping");
        };

        this.dragover = e => {
            e.stopPropagation();
            e.preventDefault();
        };

        this.dragleave = e => {
            e.stopPropagation();
            e.preventDefault();
            el.classList.remove("dropping");
        };

        this.drop = e => {
            e.stopPropagation();
            e.preventDefault();

            el.classList.remove("dropping");

            onDropCallback(e.dataTransfer.files, e);
        };

        el.addEventListener("dragenter", this.dragenter, false);
        el.addEventListener("dragover", this.dragover, false);
        el.addEventListener("dragleave", this.dragleave, false);
        el.addEventListener("drop", this.drop, false);
    }
}

